export default __webpack_public_path__ + "static/media/fwTGGaij.805c2b6d.svg";